export default __webpack_public_path__ + "static/media/Weather-App.eb57da70.png";